// parsePartySize は AI 抽出の人数文字列 (例: "2名"、"2〜3名") から人数を返す。
// 「2〜3名」のような範囲表現は、着席できないリスクを避けるため大きい方に寄せる (concierge の
// extractMaxDigits と同方針)。「1組」のような「組」表現は実際の着席人数と一致しない可能性が
// あるため null (人数不明として扱う)。数字が無い・1 未満も null。
// 店舗詳細画面の空席確認 (features/shops) とコース詳細画面の人数初期値 (features/courses) の
// 双方から使うため、feature 間 import を避けて共有層に置く (ADR-009)。
export function parsePartySize(raw: string): number | null {
  if (raw.includes("組")) return null;
  const matches = [...raw.matchAll(/\d+/g)];
  if (matches.length === 0) return null;
  const max = Math.max(...matches.map((m) => Number(m[0])));
  return max >= 1 ? max : null;
}
